// import router from 'sky-engine/router'
import CookieUtil, { getToken, setToken, removeToken } from 'sky-engine/utils/auth'

import { getUserInfo } from '../../api/user'

import { getIndexCategory } from '@/api/help'
import { loginByPassword, logout } from '@/api/login'
import { encrypt } from '@/utils'

const user = {
  state: {
    status: CookieUtil.getStatus(), // 标致用户是否登录过
    name: localStorage.getItem('name'),
    uid: '',
    role: '',
    token: getToken,
    permissions: {},
    userInfo: {},
    maintenanceState: false,
    maintenanceOrgName: '',
    maintenanceOrgId: '',
    websocket: null,
    title: '',
    downloadId: '',
    fixedModuleIds: [],
    isLogined: localStorage.getItem('isLogined') === 'true'
  },
  mutations: {
    SET_STATUS: (state, status) => {
      state.status = status
      localStorage.setItem('isLogined', status)
      state.isLogined = status
    },
    SET_NAME: (state, name) => {
      localStorage.setItem('name', name)
      state.name = name
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_UID: (state, uid) => {
      state.uid = uid
    },
    SET_ROLE: (state, role) => {
      state.role = role
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_TITLE: (state, title) => {
      state.title = title
    },
    SET_DOWNLOAD_ID: (state, downloadId) => {
      state.downloadId = downloadId
    },
    SET_FIXED_IDS: (state, rowIds) => {
      state.fixedModuleIds = rowIds
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
    }
  },

  actions: {
    async LoginByPassword({ commit }, userInfo) {
      await loginByPassword({
        userPhone: userInfo.userPhone.trim(),
        password: encrypt(userInfo.password.trim())
      }).then(response => {
        // 标致已登录
        CookieUtil.setStatus(true)
        commit('SET_STATUS', true)
        // 设置cookeise
        if (response.data.content.token) {
          const token = response.data.content.token
          setToken(token)
          // 设置store
          commit('SET_TOKEN', token)
          commit('SET_NAME', response.data.content.realName)
          commit('SET_STATUS', true)
        }
      })
    },
    // 获取用户信息
    GetUserInfo({ commit, state }, projectId) {
      return getUserInfo({ projectId }).then(response => {
        if (response.data !== null && typeof response.data === 'object' && response.data.status === 'SUCCESS') {
          // 由于mockjs 不支持自定义状态码只能这样hack
          const data = response.data.content
          commit('SET_NAME', data.realName ? data.realName : data.userName)
          commit('SET_UID', data.userId)
          commit('SET_PERMISSIONS', data.permissions || [])
          commit('SET_USER_INFO', data)
          return Promise.resolve(response)
        }
        return Promise.reject(response)
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return logout().then(response => {
        // 标致退出登录
        this.dispatch('FedLogOut')
        // 临时代码,与后端对接后需要删除
      })
    },

    // 前端 登出
    FedLogOut({ commit, state }) {
      return new Promise(resolve => {
        commit('SET_STATUS', false)
        commit('SET_NAME', '')
        commit('SET_UID', '')
        CookieUtil.removeStatus()
        // 清空缓存token
        commit('SET_TOKEN', '')
        commit('SET_ROLE', '')
        commit('SET_PERMISSIONS', [])
        removeToken()
        resolve()
      })
    },
    // 获取首页配置
    getIndexCategory({ commit, state }) {
      return getIndexCategory().then(response => {
        const content = response.data.content
        commit('SET_DOWNLOAD_ID', content.downLoadId)
        commit('SET_FIXED_IDS', content.rowIds)
      })
    }
  },
  getters: {
    token: state => state.token,
    name: state => state.name,
    status: state => state.status,
    uid: state => state.uid,
    role: state => state.role,
    userInfo: state => state.userInfo,
    title: state => state.title,
    downloadId: state => state.downloadId,
    fixedModuleIds: state => state.fixedModuleIds,
    isLogined: state => state.isLogined
  }
}

export default user
